import { render, staticRenderFns } from "./Step01.vue?vue&type=template&id=d06fffe4&scoped=true&"
import script from "./Step01.vue?vue&type=script&lang=js&"
export * from "./Step01.vue?vue&type=script&lang=js&"
import style0 from "./Step01.vue?vue&type=style&index=0&id=d06fffe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06fffe4",
  null
  
)

export default component.exports